/* Kendi favori kalbimiz — wishlist-new.vercel.app'e app proxy üzerinden konuşur.
 *
 * Kimlik istemcide tutulmuyor: istek mağazanın kendi alan adına
 * (/a/favoriler/...) gidiyor, Shopify araya imzalı `logged_in_customer_id`
 * koyuyor. Jeton yok, e-posta yok, CORS yok.
 *
 * Kalbin dışında bir iş daha görüyor: ekleme/çıkarma sonrası "Favorilere
 * eklendi" bildirimi gösteriyor. Kutuyu bu dosya üretiyor, stili
 * assets/wl-heart.css içinde.
 *
 * Düğmeleri artık tema basıyor (snippets/wishlist-app-links.liquid), biz sadece
 * bağlanıyoruz. Önceki sürüm iWish'in etiketlerinin yanına ikinci bir kalp
 * iliştiriyordu; o karşılaştırma aşaması bitti.
 *
 * NOT: Koleksiyon sayfalarındaki kartları Boost SD kendi JS'iyle çiziyor ve
 * kalbi de o enjekte ediyor (boost-code-editor/customization.js). Orası bu
 * dosyanın erişebildiği bir yer değil; koleksiyon sayfaları iWish'te kalmaya
 * devam ediyor ve ayrı bir adımda taşınacak.
 */
(function () {
  'use strict';

  // Proxy yolu. Favorilerim sayfası kendi adresini Shopify'ın path_prefix
  // beyanından öğreniyor ama kalp sıradan tema sayfalarında çalışıyor, öyle bir
  // beyan görmüyor — burada sabit. /a/favoriler kalıcı bir yol (bkz. GECIS.md).
  var API = '/a/favoriler/api';
  var SEL = '[data-wl-variant]';

  var favorites = null;    // Set; yüklenene kadar null
  var writeToken = '';     // yazma jetonu; listeyle birlikte geliyor
  var pending = {};        // variantId -> true, çift tıklamayı yutar

  /* ---------- ağ ---------- */

  // POST'u text/plain gönderiyoruz: basit istek sayılır, preflight çıkmaz.
  function post(path, body) {
    return fetch(API + path, {
      method: 'POST',
      headers: { 'content-type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    });
  }

  function loadFavorites() {
    return fetch(API + '/liste', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (d) {
        favorites = new Set((d.items || []).map(String));
        // Yazma jetonu: sunucu yalnız bu yanıtta veriyor ve bu yanıtı sadece
        // aynı kaynaktaki betik okuyabiliyor. Başka sitenin yazması böyle
        // engelleniyor (CSRF).
        writeToken = d.token || '';
        paintAll();
      })
      .catch(function (err) {
        console.warn('[wl] liste okunamadı', err);
        favorites = new Set();
      });
  }

  /* ---------- boyama ---------- */

  function variantOf(btn) {
    var m = String(btn.getAttribute('data-wl-variant') || '').match(/(\d+)\s*$/);
    return m ? m[1] : '';
  }

  function paint(btn) {
    if (favorites === null) return;              // henüz bilmiyoruz
    var on = favorites.has(variantOf(btn));
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? 'Favorilerden çıkar' : 'Favorilere ekle';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
  }

  function paintAll() {
    document.querySelectorAll(SEL).forEach(paint);
  }

  /* ---------- bildirim ----------
   * Sepete eklerken çıkan kutunun kardeşi. Kalp küçük ve sessiz bir düğme;
   * dolduğunu görmeyen müşteri "ekledim mi?" diye Favorilerim'e gidiyordu. */
  var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"></circle>' +
    '<path d="M8 12.3l2.5 2.5L16.5 9" stroke="currentColor" stroke-width="1.8"' +
    ' stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function toastEl() {
    var el = document.querySelector('.wl-toast');
    if (el) return el;

    el = document.createElement('div');
    el.className = 'wl-toast';
    // Bildirim ekrana sonradan düşüyor; ekran okuyucu metni kendiliğinden okusun.
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="wl-toast__icon">' + ICON_OK + '</div>' +
      '<div class="wl-toast__content">' +
        '<p class="wl-toast__text"></p>' +
        '<a class="wl-toast__button" href="/a/favoriler">Favorilerim</a>' +
      '</div>';
    document.body.appendChild(el);
    return el;
  }

  function toast(message, opts) {
    var el = toastEl();
    var withLink = !opts || opts.link !== false;

    el.querySelector('.wl-toast__text').textContent = message;
    el.querySelector('.wl-toast__button').style.display = withLink ? 'inline-flex' : 'none';
    el.classList.toggle('is-off', Boolean(opts && opts.off));

    clearTimeout(el.__timer);
    el.classList.add('is-visible');
    el.__timer = setTimeout(function () { el.classList.remove('is-visible'); }, 3000);
  }

  /* ---------- tıklama ---------- */

  function onClick(e) {
    var btn = e.target.closest(SEL);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();                          // kart linkini tetiklemesin

    var id = variantOf(btn);
    if (!id || favorites === null || pending[id]) return;

    var adding = !favorites.has(id);

    // İyimser boyama: tıklayan insan ağı beklemesin.
    pending[id] = true;
    if (adding) favorites.add(id); else favorites.delete(id);
    paintAll();
    if (adding) toast('Favorilere eklendi.');
    else toast('Favorilerden çıkarıldı.', { link: false, off: true });

    post('/degistir', { variantId: id, action: adding ? 'add' : 'remove', token: writeToken })
      .then(function (r) {
        if (r.status === 401) {
          // Giriş yok. Favoriyi kaybetmeyelim: dönüşte aynı sayfaya gelsin.
          window.location.href = '/account/login?return_url=' +
            encodeURIComponent(window.location.pathname + window.location.search);
          throw new Error('giris_gerekli');
        }
        if (!r.ok) throw new Error('http_' + r.status);
      })
      .catch(function (err) {
        if (err && err.message === 'giris_gerekli') return;
        // Yazamadıysak boyamayı geri al — ekranda yalan kalmasın. Bildirim de
        // öyle: "eklendi" deyip eklememiş olmak, hiç haber vermemekten kötü.
        console.warn('[wl] yazılamadı', err);
        if (adding) favorites.delete(id); else favorites.add(id);
        paintAll();
        toast('Bağlantı kurulamadı, tekrar dene.', { link: false, off: true });
      })
      .then(function () { delete pending[id]; });
  }

  /* ---------- başlangıç ---------- */

  function start() {
    loadFavorites();

    // Tek dinleyici: karuseller ve filtreler kart bastıkça yeniden bağlanmaya
    // gerek kalmıyor.
    document.addEventListener('click', onClick, true);

    // Sonradan gelen kartların kalbi de doğru dolulukta açılsın.
    //
    // Sayaç kurulduysa DOKUNMUYORUZ. Önceki hâli her değişiklikte
    // clearTimeout ile sıfırlıyordu; bu sayfada DOM hiç durulmadığı için
    // (Boost, tembel görseller, popup'lar) sayaç hiç dolmuyor ve paintAll
    // çalışmıyordu. Görünen sonucu: favoriden çıkarılan ürünün kalbi dolu
    // kalıyordu, çünkü onu boşaltacak boyama hiç koşmuyordu.
    //
    // Şimdiki hâli en fazla 150ms'de bir çalışır ama MUTLAKA çalışır.
    var timer = null;
    new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () { timer = null; paintAll(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
